<template>
  <div class="list-item-navigation p-3" @click="$router.push(navigationRoute)">
    <div class="row">
      <div
        class="col-1 d-none d-sm-block list-item-navigation--icon list-item--icon"
      >
        <i :class="getListItemClass()" aria-hidden="true"></i>
      </div>
      <div class="col list-item-navigation--content">
        <div class="list-item-navigation--content-title" v-text="title" />
        <div class="list-item-navigation--content-subtitle" v-text="subtitle" />
      </div>
      <div class="col-auto d-flex align-items-center mr-4">
        <i class="fa fa-caret-right" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "user"
    },
    title: {
      type: String,
      default: "title"
    },
    subtitle: {
      type: String,
      default: "subtitle"
    },
    navigationRoute: {
      type: String,
      default: "/"
    }
  },
  methods: {
    getListItemClass() {
      return `fa fa-${this.icon}`;
    }
  }
};
</script>
<style lang="scss">
.list-item-navigation {
  &:hover,
  &:focus,
  &:active {
    cursor: pointer;
    background: var(--ci-gamma-400-bg, #e4e6e7);
    transition: background-color 300ms ease-out;
  }

  .list-item-navigation--icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    & > i {
      color: var(--ci-gamma-600-bg, #5c6970);
      font-size: 24px;
      letter-spacing: normal;
      user-select: none;
    }
  }
}
.list-item--icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  & > i {
    color: var(--ci-gamma-600-bg, #5c6970);
    font-size: 24px;
    letter-spacing: normal;
    user-select: none;
  }
}
</style>
